import View3D from "components/Product/View3D"
import PropTypes from "prop-types"
import React, { Fragment } from "react"
import {Component} from "react"
import shop from "shop/shop"
import { Button, Card, Container, Icon, Input, Label, Message, Popup, Select, Table , Image, Tab, TabPane, MenuItem, Responsive } from "semantic-ui-react"

import "style/ProductImages.scss"
import Slider from "components/Slider/Slider"
import ImageWithFallback from "components/ImageWithFallback"

export default class ProductImages extends Component {

	render() {
		const {images, image, onClick, product} = this.props
		if ( images.length === 0 ) {
			return <div className="ProductImages">
				<div className="">
					<div><ImageWithFallback fallback={"/image/placeholder.png"} src={image} /></div>
				</div>
			</div>
		}

		//console.log("images", images)
		const panesTest = [


		]

		const getPanes = () =>{
			return images.map(({ img_src_small,img_src_large, img_src_medium }) => ({
				menuItem: (
					<MenuItem style={{maxWidth:"120px",maxHeight:"120px",overflow: "hidden"}} key={img_src_small} className="pl2 pt2 pb2">
					  <div key={img_src_small} className="pl2 pt2 pb2">
						<ImageWithFallback style={{maxWidth:"100px",maxHeight:"100px",overflow: "hidden"}}
							fallback={"/image/placeholder.png"}
							alt={`${product.title}`}
							title={`${product.title}`}
							src={img_src_small} />
					</div>
					</MenuItem>
				  ),
				render: () => <Tab.Pane><div key={img_src_medium} style={{height: "auto", display:"flex", valign:"middle",justifyContent: 'center', alignItems: 'center',
					overflow: "hidden" }} className="pa2">
						<Responsive minWidth={769}>
						<ImageWithFallback style={{maxWidth: "500px",maxHeight: "500px", minWidth: "500px",minHeight: "500px" }}
					fallback={"/image/placeholder.png"}
					alt={`${product.title}`}
					title={`${product.title}`}

					src={img_src_large} />
						</Responsive>
						<Responsive maxWidth={768}>
						<ImageWithFallback style={{maxWidth: "500px",maxHeight: "500px" }}
					fallback={"/image/placeholder.png"}
					alt={`${product.title}`}
					title={`${product.title}`}

					src={img_src_large} />
						</Responsive>
			</div></Tab.Pane>,
			}));
		}

		return (<Fragment>
			{shop.config.plugin["imagesSidebar"] && <Tab menu={{ fluid: true, vertical: true, tabular: true, borderless: true }} panes={getPanes()} className="pt2 pr6" />}
			{!shop.config.plugin["imagesSidebar"] && <div className="ProductImages">
				<div className=" ">
				<Responsive minWidth={769}>
				<Slider>
						{images.map( ( {img_src_large, img_src_medium} ) => (<ImageWithFallback style={{maxWidth: "500px",maxHeight: "500px", minWidth: "70px",minHeight: "70px"}}
							fallback={"/image/placeholder.png"}
							key={img_src_large}
							alt={`${product.title}`}
							title={`${product.title}`}

							src={img_src_large} />) )}
					</Slider>
						</Responsive>
						<Responsive maxWidth={768}>
						<Slider>
						{images.map( ( {img_src_large, img_src_medium} ) => (<ImageWithFallback style={{paddingTop: "2%",maxWidth: "350px",maxHeight: "350px", minWidth: "70px",minHeight: "70px"}}
							fallback={"/image/placeholder.png"}
							key={img_src_large}
							alt={`${product.title}`}
							title={`${product.title}`}

							src={img_src_large} />) )}
					</Slider>
						</Responsive>
				</div>


				<div className="product-images pt2 ">

					{images.map( ( {img_src_large, img_src_medium} ) => <div key={img_src_medium} className="pa2">
						<Responsive minWidth={769}>
						<ImageWithFallback style={{maxWidth: "70px",maxHeight: "70px", minWidth: "70px",minHeight: "70px", overflow: "hidden",objectFit: "contain"}}
							fallback={"/image/placeholder.png"}
							className="img-thumbnail "
							alt={`${product.title}`}
							title={`${product.title}`}

							src={img_src_medium} />
						</Responsive>
						<Responsive maxWidth={768}>
						<ImageWithFallback style={{maxWidth: "70px",maxHeight: "70px", minWidth: "70px",minHeight: "70px", overflow: "hidden",objectFit: "contain"}}
							fallback={"/image/placeholder.png"}
							className="img-thumbnail "
							alt={`${product.title}`}
							title={`${product.title}`}

							src={img_src_medium} />
						</Responsive>
					</div> )}


					{shop.config.plugin["view3D"] && <View3D id={product.map_id} title={product.desc.short_des} />}
				</div>
			</div>}
			</Fragment>
		)
	}
}

ProductImages.propTypes = {
	images : PropTypes.any,
	image  : PropTypes.any,
	onClick: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/theme/hvz/components/Product/ProductImages.js